// extracted by mini-css-extract-plugin
export default {"menu":"main-menu_menu__7wGNA","item":"main-menu_item__rKD++","subMenu":"main-menu_subMenu__gJnhD"};